import { useAuth0 } from '@auth0/auth0-react';

import { USER_ID_URL } from 'components/miscellaneous/Auth0TokenHandler';
import { useIsLoading } from 'store/modules/loading/hooks';
import MyUserActionType from 'store/modules/myUser/constants';
import { useMyUser } from 'store/modules/myUser/hooks';

/**
 * True when loadMyUser has settled for the Auth0 user currently signed in.
 * Prevents routing (e.g. auto-redirect to enterprise) on a stale prior user's profile.
 */
export function useMyUserMatchesAuth0User(): boolean {
  const { user: auth0User } = useAuth0();
  const myUser = useMyUser();
  const isLoadingMyUser = useIsLoading(MyUserActionType.LOAD_MY_USER_REQUEST);

  if (!auth0User || isLoadingMyUser) {
    return false;
  }

  const authUserId = +auth0User[USER_ID_URL];
  if (!authUserId) {
    return false;
  }

  // Check myUser.id === authUserId is not enough. When user signs in, we store
  // user id (from Auth0) alone into myUser, then init the requestMyUser. If
  // we manage to get the complete user info, there must be a username.
  return !!myUser?.username && myUser.id === authUserId;
}
